<template>
  <div>
    <div class="dashboard-tab">
      <h3 class="tab-title">统计中心</h3>     
      
      <!-- 统计中心核心内容 -->
      <div v-if="tenantInfo.versionName!==null" class="stats-content">
        <el-tabs v-model="activeTab" type="border-card" class="stats-tabs">
  <!-- ========== 新增：全局时间范围选择器 ========== -->
            <div class="global-time-filter">
              <div class="filter-label">时间范围：</div>
              <div class="filter-controls">
                <el-select 
                  v-model="timeGroupBy" 
                  size="small" 
                  @change="handleGlobalGroupByChange" 
                  style="width: 120px;"
                >
                  <el-option label="按小时" value="HOUR"></el-option>
                  <el-option label="按天" value="DAY"></el-option>
                  <el-option label="按周" value="WEEK"></el-option>
                  <el-option label="按月" value="MONTH"></el-option>
                </el-select>
                <el-date-picker
                  v-model="dateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  size="small"
                  value-format="yyyy-MM-dd"
                  @change="handleGlobalDateRangeChange"
                  style="width: 260px; margin-left: 10px;"
                ></el-date-picker>
              </div>
            </div>
            <!-- ============================================ -->          
          <!-- Tab 1: 仪表盘 -->
          <el-tab-pane label="📊 仪表盘" name="dashboard">
            <KPICards :metrics="overviewMetrics" :loading="loading.overview" />
            <TrafficTrendChart 
              :trend-data="trafficData" 
              :loading="loading.traffic" 
             :time-group-by="timeGroupBy"
              :date-range="dateRange"
            />
          </el-tab-pane>
          
          <!-- Tab 2: 统计报表 -->
          <el-tab-pane label="📋 统计报表" name="reports">
            <ReportMenu @select-report="handleReportSelect" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    
    <!-- 反馈明细弹窗 -->
    <FeedbackDetailDialog ref="feedbackDialog" />
     <!-- 未知问题TOP榜弹窗 -->
    <UnknownQuestionsDialog ref="UnknownQuestionsDialog" /> 
    <!-- 会话全链路明细弹窗 -->
    <ConversationListDialog ref="conversationDialog" />    
    <!-- 知识库文档表现报表弹窗 -->
    <KnowledgePerformanceDialog ref="knowledgePerformanceDialog" />   
    <HotSearchDialog ref="hotSearchDialog" />   
  </div>
</template>

<script>
//import { load_version_settings/*, load_my_fuel_package */} from '@/api/tenant/plan'
import { getOverviewMetrics, getTrafficTrend } from '@/api/dashboard'
import KPICards from './KPICards.vue'
import TrafficTrendChart from './TrafficTrendChart.vue'
import ReportMenu from './ReportMenu.vue'
import FeedbackDetailDialog from './FeedbackDetailDialog.vue'
import UnknownQuestionsDialog from './UnknownQuestionsDialog.vue'
import ConversationListDialog from './ConversationListDialog.vue'
import KnowledgePerformanceDialog from './KnowledgePerformanceDialog.vue'
import HotSearchDialog from './HotSearchDialog.vue'

export default {
  name: "statisticsCenter",
  components: {
    KPICards,
    TrafficTrendChart,
    ReportMenu,
    FeedbackDetailDialog,
    UnknownQuestionsDialog,
    ConversationListDialog,
    KnowledgePerformanceDialog,
    HotSearchDialog  
  },
  data() {
    return {
      activeTab: 'dashboard',
      loading: {
        overview: false,
        traffic: false
      },
      // ========== 时间范围选择器数据 ==========
      //timeGroupBy: 'DAY',
      dateRange: [],      
     // ==========================================      
      overviewMetrics: {
        totalQueries: 0,
        uniqueSessions: 0,
        avgResponseTimeMs: 0,
        unknownQuestionCount: 0,
        hitRate: 0,
        positiveRatingRate: 0,
        aiResolutionRate: 0,
        pendingReviewDocs: 0
      },
      trafficData: [],
      timeGroupBy: 'DAY',
      timeRange: {
        startTime: this.getDefaultStartTime(),
        endTime: this.formatDateTime(new Date())
      },
      
      // 套餐相关（保持原有）
      version_settings: [],
      my_fuel_packages: [],
      current_version_setting: null,
      current_fuel_package: null,
      fuelPackages: [],
      selectedFuelPackageId: null,
      cartItems: [],
      cartTotal: 0,
      open_plan: false,
      open_fuel: false,
      versionCode_selected: '',
      pkgCodeSelected: ''
    }
  },
  computed: {
    tenantInfo() {
      return this.$store.getters['auth/currentTenant']
    },
    tenantId() {
      return this.tenantInfo?.tenantId || null
    }
  },
async mounted() {
  console.log("当前 tenantInfo:", this.tenantInfo)
/*  if(this.tenantInfo && this.tenantInfo.status && this.tenantInfo.status.trim()!=='APPROVED'){
      this.$message.error('租户状态未激活');  
      this.logout();
  }     */
  try {
    // 初始化默认时间范围
    this.initDefaultDateRange()
    console.log('📅 初始化后的 dateRange:', this.dateRange)
    console.log('📅 初始化后的 timeRange:', this.timeRange)
    
    // 加载仪表盘数据
    await this.loadDashboardData()
    
  } catch (error) {
    console.error("加载数据失败:", error)
  }
},
  methods: {
 // ========== 新增：初始化默认时间范围 ==========
  initDefaultDateRange() {
    const range = this.getDefaultDateRange(this.timeGroupBy)
    // ✅ 只取日期部分，去掉时间
    this.dateRange = [
      range.startTime.substring(0, 10), 
      range.endTime.substring(0, 10)
    ]
    this.timeRange = {
      startTime: range.startTime,
      endTime: range.endTime
    }
  },

    getDefaultDateRange(groupBy) {
      const end = new Date()
      const start = new Date()
      
      switch (groupBy) {
        case 'HOUR':
          start.setHours(start.getHours() - 24)
          return {
            startTime: this.formatDateTime(start),
            endTime: this.formatDateTime(end)
          }
        case 'DAY':
          start.setDate(start.getDate() - 14)
          break
        case 'WEEK':
          start.setDate(start.getDate() - 42)
          break
        case 'MONTH':
          start.setMonth(start.getMonth() - 6)
          break
        default:
          start.setDate(start.getDate() - 14)
      }
      
      return {
        startTime: this.formatDateTime(start),
        endTime: this.formatDateTime(end)
      }
    },

    // ========== 新增：全局时间分组切换 ==========
    handleGlobalGroupByChange(value) {
      this.timeGroupBy = value
      const range = this.getDefaultDateRange(value)
      this.dateRange = [range.startTime, range.endTime]
      this.timeRange = {
        startTime: range.startTime,
        endTime: range.endTime
      }
      this.loadDashboardData()
    },
    // ========== 新增：全局日期范围切换 ==========
    handleGlobalDateRangeChange(val) {
      if (val) {
        this.timeRange = {
          startTime: val[0] + ' 00:00:00',
          endTime: val[1] + ' 23:59:59'
        }
        this.loadDashboardData()
      }
    },
    // ==========================================


    // ===== 时间格式化 =====
    formatDateTime(dateStr) {
      if (!dateStr) return '-'
      let date
      if (typeof dateStr === 'string') {
        date = new Date(dateStr)
      } else if (dateStr instanceof Date) {
        date = dateStr
      } else if (typeof dateStr === 'number') {
        date = new Date(dateStr)
      } else {
        // 处理 Timestamp 对象
        try {
          date = new Date(dateStr.getTime ? dateStr.getTime() : dateStr)
        } catch (e) {
          return '-'
        }
      }
      if (isNaN(date.getTime())) return '-'
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    
    getDefaultStartTime() {
      const date = new Date()
      date.setDate(date.getDate() - 7)
      return this.formatDateTime(date)
    },

    // ===== 加载仪表盘数据 =====
    async loadDashboardData() {
      this.loading.overview = true
      this.loading.traffic = true
      
      try {
        const params = {
          startTime: this.timeRange.startTime,
          endTime: this.timeRange.endTime,
          tenantId: this.tenantInfo.tenantId,
          timeGroupBy: this.timeGroupBy || 'DAY'
        }
        
        console.log('📤 请求参数:', params)
        
        const [overviewRes, trafficRes] = await Promise.all([
          getOverviewMetrics(params),
          getTrafficTrend(params)
        ])
        
        // 解析概览数据
        if (overviewRes?.data?.code === 200) {
          const raw = overviewRes.data.data
          this.overviewMetrics = {
            totalQueries: raw.total_queries || 0,
            uniqueSessions: raw.unique_sessions || 0,
            avgResponseTimeMs: raw.avg_response_time_ms || 0,
            unknownQuestionCount: raw.unknown_question_count || 0,
            hitRate: raw.hit_rate || 0,
            positiveRatingRate: raw.positive_rating_rate || 0,
            aiResolutionRate: raw.ai_resolution_rate || 0,
            pendingReviewDocs: raw.pending_review_docs || 0
          }
          console.log('✅ 概览数据:', this.overviewMetrics)
        } else {
          console.warn('⚠️ 概览数据获取失败:', overviewRes?.data?.message)
        }
        
        // 解析流量趋势数据
console.log("trafficRes", trafficRes);

        if (trafficRes?.data?.code === 200) {
          this.trafficData = trafficRes.data.data || []
          console.log('✅ 流量趋势数据条数:', this.trafficData.length)
        } else {
          console.warn('⚠️ 流量趋势数据获取失败:', trafficRes?.data?.message)
          this.trafficData = []
        }
        
      } catch (error) {
        console.error('❌ 加载仪表盘数据失败:', error)
        this.$message.error('加载仪表盘数据失败: ' + (error.message || '未知错误'))
      } finally {
        this.loading.overview = false
        this.loading.traffic = false
      }
    },

    // ===== 时间范围变化处理 =====
    handleTimeRangeChange(payload) {
      console.log('📥 收到时间范围变化:', payload)
      
      // 直接使用传入的时间，不再格式化
      this.timeRange = {
        startTime: payload.startTime,
        endTime: payload.endTime
      }
      
      this.timeGroupBy = payload.timeGroupBy || 'DAY'
      
      // 重新加载数据
      this.loadDashboardData()
    },

    // ===== 报表菜单选择 =====
    handleReportSelect(reportName) {
      console.log('📊 选择报表:', reportName)
      
      switch (reportName) {
        case 'feedback':
          // 打开反馈明细弹窗
          if (this.$refs.feedbackDialog) {
            this.$refs.feedbackDialog.open()
          } else {
            console.warn('feedbackDialog ref 不存在')
            this.$message.error('弹窗组件未加载')
          }
          break
          
        case 'unknown-questions':
          // 打开未知问题TOP榜弹窗
          if (this.$refs.UnknownQuestionsDialog) {
            this.$refs.UnknownQuestionsDialog.open()
          } else {
            console.warn('UnknownQuestionsDialog ref 不存在')
            this.$message.error('弹窗组件未加载')
          }
          break
          
        case 'conversation-detail':
          // ✅ 打开会话全链路明细弹窗
          if (this.$refs.conversationDialog) {
            this.$refs.conversationDialog.open()
          } else {
            console.warn('conversationDialog ref 不存在')
            this.$message.error('弹窗组件未加载')
          }
          break
          
        case 'knowledge-performance':            // 知识库文档表现报表
          if (this.$refs.knowledgePerformanceDialog) {
            this.$refs.knowledgePerformanceDialog.open()
          } else {
            console.warn('knowledgePerformanceDialog ref 不存在')
            this.$message.error('弹窗组件未加载')
          }
          break
          
case 'hot-search':
  if (this.$refs.hotSearchDialog) {
    this.$refs.hotSearchDialog.open()
  } else {
    console.warn('hotSearchDialog ref 不存在')
    this.$message.error('弹窗组件未加载')
  }
  break
          
        default:
          // 其他报表跳转
          this.$router.push(`/statistics/reports/${reportName}`)
      }
    },

    async logout() {
      try {
        // 调用 Vuex 中的 logout action
        await this.$store.dispatch('auth/logout')
        // 退出成功后跳转到登录页
        this.$router.push('/login')
      } catch (error) {
        console.error('退出登录失败:', error)
        // 即使退出API调用失败，也强制清除本地状态并跳转
        this.$store.commit('auth/CLEAR_AUTH')
        this.$router.push('/login')
      }
    },    
  }
}
</script>

<style scoped>
/* ========== 新增：全局时间过滤器样式 ========== */
.global-time-filter {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 12px 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}

.filter-label {
  font-size: 14px;
  font-weight: 600;
  color: #606266;
  white-space: nowrap;
  margin-right: 10px;
}

.filter-controls {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.dashboard-tab { padding: 0; }
.tab-title { color: #333; margin-bottom: 25px; font-size: 1.5rem; font-weight: 500; }
.info-section { display: flex; align-items: center; justify-content: flex-start; margin-bottom: 20px; flex-wrap: wrap; gap: 15px; }
.info-text { color: #666; font-size: 1rem; }

.stats-tabs { border-radius: 8px; box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05); }
.stats-tabs ::v-deep .el-tabs__content { padding: 20px; }

/* 其他原有样式保持不变 */
</style>